var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Bold_Filter",
    "data-name": "Iconly/Bold/Filter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.501,
    height: 18.223,
    viewBox: "0 0 20.501 18.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M16.976,11.3a3.464,3.464,0,1,1-3.525,3.464A3.494,3.494,0,0,1,16.976,11.3Zm-8.69,1.987a1.519,1.519,0,1,1,0,3.037H1.546a1.519,1.519,0,1,1,0-3.037h6.74ZM3.525,0A3.494,3.494,0,0,1,7.05,3.463,3.494,3.494,0,0,1,3.525,6.927,3.5,3.5,0,0,1,0,3.463,3.5,3.5,0,0,1,3.525,0ZM18.956,1.946a1.518,1.518,0,1,1,0,3.036h-6.74a1.518,1.518,0,1,1,0-3.036h6.74Z",
    transform: "translate(0 0)",
    fill: "#142e38"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.f121fec38b3d87f4af4ddcafe8dac53e.svg";
export { ForwardRef as ReactComponent };